import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation } from "react-i18next";

export function SelectOrderTypeSkeleton() {
  const { t } = useTranslation(["fit"]);

  return (
    <CenteredLayout
      variant={CenteredLayoutVariant.Default}
      title={t("fit:SelectOrderType")}
      subTitle={t("fit:SelectOrderTypeDescription")}
    >
      <div className="flex flex-col gap-2">
        <Skeleton className="h-6 w-40" />
        <div className="grid grid-cols-2 gap-4">
          <Skeleton className="h-26 rounded-lg" />
          <Skeleton className="h-26 rounded-lg" />
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <Skeleton className="h-6 w-40" />
        <div className="grid grid-cols-3 gap-4">
          <Skeleton className="h-26 rounded-lg" />
          <Skeleton className="h-26 rounded-lg" />
          <Skeleton className="h-26 rounded-lg" />
        </div>
      </div>

      <Skeleton className="h-9 w-20" />
    </CenteredLayout>
  );
}
